//state data for generic area functionality
// https://mccglc.atlassian.net/l/c/1D1xv92B for DOCS

import { lightOrDark } from '@/functions/utility.js';

const state = {
  // currentArea state is stored in api_navigation.js (store)
  lastSwitchAreaTime: 0,
};

const getters = {
  getLastSwitchAreaTime: (state) => state.lastSwitchAreaTime,
  getIfAreaBackgroundIsLightOrDark: (state,getters) => (col) => {
    let bgColour = col || getters.getCurrentAreaPrimaryColour
    return lightOrDark(bgColour)
  },
};

const mutations = {
  setLastSwitchAreaTime(state, data) {
    state.lastSwitchAreaTime = data;
  },
};

const actions = {
};

export default {
  state,
  getters,
  mutations,
  actions
};
